import { Navigate } from "react-router-dom";
import { useAuth, homePathFor } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles, requireApproved = true }) {
  const { user, checked } = useAuth();

  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-blue-700" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homePathFor(user)} replace />;
  if (requireApproved && user.role !== "admin" && user.status !== "approved")
    return <Navigate to="/in-attesa" replace />;
  return children;
}
